<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required">Title</label>
          <div class="p-col">
            <InputText id="name" type="text" class="" v-model="obj_data.name" placeholder="Input (max: 255 charactors)"  @Input="validateMaxlength" :maxlength="255"/>
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required">Short description </label>
          <div class="p-col">
                <Textarea v-model="obj_data.short_description"  placeholder="Input (max: 500 charactors)" :rows="4" id="short_description" @Input="validateMaxlength" :maxlength="500"></Textarea>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Description </label>
          <div class="p-col">
            <input class="input_tmp_validator" id="validator_content_description">
            <CkditorCore :contentSet="obj_data.description" @newdata="handleDataCkditor($event, 0, 'description')">
            </CkditorCore>

          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right">Order</label>
          <div class="p-col">
            <InputText id="name" type="text" class="" v-model="obj_data.ordinal" placeholder="" />
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.active" :binary="true" />
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>
      </div>
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>
<script>
import CkditorCore from '../CkditorCore';

export default {
  components: {
    CkditorCore,
  },
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      obj_data: {},
      componentKey: 0
    }
  },
  async mounted() {
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.model;
      console.log('this.obj_datathis.obj_datathis.obj_data', this.obj_data);
      
      this.componentKey++;
    } else {
      //thêm mới
      this.obj_data = {
        active: true,
        ordinal: null,
      };
      this.componentKey++;
    }
  },
  methods: {
    validateMaxlength(e) {
      if (e.target.value.length > e.target.maxLength) {
        e.target.value = e.target.value.slice(0, e.target.maxLength);
      }
    },
    handleDataCkditor: function (e, index, key) {
      var dataContent = e;
      if (Array.isArray(dataContent)) {
        dataContent = dataContent.join(' ');
      }
      console.log('dataContent', dataContent);
      if (key == 'description') {
        this.obj_data.description = dataContent;
      }
    },

    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};
      const fieldsToValidate = [
        { id: "name", value: this.obj_data.name },
        { id: "short_description", value: this.obj_data.short_description },
        { id: "validator_content_description", value: this.obj_data.description },
      ];
      let isFormInvalid = false;
      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);
        if (inputElement && (inputElement.tagName === "INPUT" || inputElement.tagName === "TEXTAREA" || inputElement.tagName === "SELECT")) {
          if (this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          }
          else {
            inputElement.setCustomValidity("");
          }
        }
      }
      let inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity() || isFormInvalid) {
        inpObj.reportValidity();
        return true;
      }
      return false;
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return
      }
      var params = {
        name: this.obj_data?.name ?? '',
        short_description: this.obj_data?.short_description ?? '',
        description: this.obj_data?.description ?? '',
        active: this.obj_data?.active ?? true,
      }
      this.$emit('save', params)
    },
  },
}
</script>

<style lang="scss">
.p-formgrid {
   padding-top: 15px;
}
.main-style-button {
  background: #0086C4;
}
.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;

}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

//style form add-edit
@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}


.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
  //border-top: none!important;
  //border: 1px solid rgba(60, 60, 60, 0.26);;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}


.p-col-fixed {
  padding: 0px !important;
  //margin:0px 0px 0px 10px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}


//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #FFDF01 !important;
  }
}
.p-col-fixed {
  font-weight: 700;
}


.p-button-outlined .p-button-label {
  color: #000000 !important;
}
</style>
